import React from "react";
import { object, array, string, number } from "prop-types";
import { Link } from "@quintype/components";

import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import { getHeadline } from "../../utils/utils";

import "./customStoryCard9.m.css";

const CustomStoryCard9 = ({ story, aspectRatio, imageType, widths, headerType }) => {
  const headline = getHeadline(story);

  return (
    <Link href={story.url} styleName="wrapper">
      <CardImage
        story={story}
        aspectRatio={aspectRatio}
        imageType={imageType}
        widths={widths}
        eager={true}
        showStoryTypeIcon={false}
      />
      <div styleName="headline-wrapper">
        <Headline text={headline} headerType={headerType} story={story} />
      </div>
    </Link>
  );
};

CustomStoryCard9.defaultProps = {
  aspectRatio: [1, 1],
  imageType: "image1x1",
  headerType: 12,
  widths: [160],
};

CustomStoryCard9.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  widths: array,
  headerType: number,
};

export default CustomStoryCard9;
